<template>
    <div class="container">
        <img id="background-login" src="/static/img/fondo.png" alt="">
        <div class="container login text-center">
            <h1>Bienvenido</h1>
            <p id="text">Ingresa tus datos</p>
        </div>
        <div method="post" action="" id="login" class="form-horizontal" role="form">
            <div class="input">
                <input type="text" v-model="data.username" name="username" placeholder="Ingresar nombre de usuario" maxlength="20">
                <div v-for="error in errors.username" id="errors">
                    {{ error }}
                </div>
            </div>
            <div class="input">
                <input type="password" v-model="data.password" name="password" placeholder="Ingresar contraseña" maxlength="20">
                <div v-for="error in errors.password" id="errors">
                    {{ error }}
                </div>
            </div>
            <div v-for="error in errors.detail" id="errors">
                {{ error }}
            </div>
            <div id="btn-login">
                <button class="btn btn-default" v-on:click="login()" id="btningresar" name="btningresar">Ingresar</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import Vue from 'vue'
    import router from '@/router'
    import Config from '@/config'

    export default {
        name: 'emt-login',
        data: function () {
            return {
                data: {
                    username: null,
                    password: null
                },
                errors: {
                    username: [],
                    password: [],
                    detail: []
                }
            }
        },
        methods: {
            login: function () {
                var self = this
                this.$http.post(Config.api + '/login/login/', self.data).then(function (response) {
                    self.loading = false
                    Config.isLogin = true
                    Config.permissions = response.body.permissions
                    Cookies.set('token', response.body.token)
                    Cookies.set('idUser', response.body.id)
                    Cookies.set('permissions', response.body.permissions)
                    Cookies.set('username', response.body.username)
                    Cookies.set('perfil', response.body.groups && response.body.groups[0])
                    Vue.http.headers.common['Authorization'] = 'JWT ' + Cookies.get('token')
                    this.$http.get(Config.api + '/pqr_type/').then(function (response) {
                        var typePqrList = []
                        for (var i = 0; i < response.body.results.length; i = i + 1) {
                            typePqrList.push({ 'value': response.body.results[i].id, 'label': response.body.results[i].name })
                        }
                        Cookies.set('typePqrList', typePqrList)
                        this.$parent.showMenuBar()
                        router.push('/home')
                    }, function (response) {
                        self.errors = response.body
                    })
                }, function (response) {
                    self.errors = response.body
                })
            },
            listener: function (e) {
                var self = this
                var containSwal = document.body.classList.contains('swal2-shown')
                if (e.key === 'Enter' && !containSwal) {
                    self.login()
                }
            }
        },
        mounted: function () {
            var self = this
            window.addEventListener('keyup', self.listener)
        },
        destroyed: function () {
            var self = this
            window.removeEventListener('keyup', self.listener)
        },
        created: function () {
            Cookies.remove('token')
            Cookies.remove('idUser')
            Cookies.remove('permissions')
            Cookies.remove('typePqrList')
            Cookies.remove('username')
            Cookies.remove('perfil')
            localStorage.removeItem('filter')
        }
    }
</script>



// WEBPACK FOOTER //
// emt-login.vue?4bb54ce7